/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import ParameterDataType from './ParameterDataType';
import ParameterLocationType from './ParameterLocationType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterDataType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterLocationType (runtime) // new

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="parameterName" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="dataType" type="{}parameterDataType"/&gt; &lt;element name="modelFilterItem" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="capabilities" type="{}parameterCapabilitiesType" minOccurs="0"/&gt; &lt;element name="invert" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="values" type="{}valueType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="location" type="{}parameterLocationType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ParameterFeedbackInfo extends MoserObject{

	parameterName = null;

	dataType = null;

	modelFilterItem = null;

	capabilities = null;

	invert = null;

	values = null;

	location = null;



	/**
	 * Gets the value of the parameterName property.
	 * @return {String} possible object is {@link String}
	 */
	getParameterName() {
		return this.parameterName;
	}

	/**
	 * Sets the value of the parameterName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setParameterName(value) {
		var oldValue = this.parameterName;
		this.parameterName = value;
		this._setAndNotify(80, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the dataType property.
	 * @return {ParameterDataType} possible object is {@link ParameterDataType}
	 */
	getDataType() {
		return this.dataType;
	}

	/**
	 * Sets the value of the dataType property.
	 * @param {ParameterDataType} value allowed object is {@link ParameterDataType}
	 */
	setDataType(value) {
		var oldValue = this.dataType;
		this.dataType = value;
		this._setAndNotify(82, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the modelFilterItem property.
	 * @return {String} possible object is {@link String}
	 */
	getModelFilterItem() {
		return this.modelFilterItem;
	}

	/**
	 * Sets the value of the modelFilterItem property.
	 * @param {String} value allowed object is {@link String}
	 */
	setModelFilterItem(value) {
		var oldValue = this.modelFilterItem;
		this.modelFilterItem = value;
		this._setAndNotify(118, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the capabilities property.
	 * @return {ParameterCapabilitiesType} possible object is {@link ParameterCapabilitiesType}
	 */
	getCapabilities() {
		return this.capabilities;
	}

	/**
	 * Sets the value of the capabilities property.
	 * @param {ParameterCapabilitiesType} value allowed object is {@link ParameterCapabilitiesType}
	 */
	setCapabilities(value) {
		var oldValue = this.capabilities;
		this.capabilities = value;
		this._setAndNotify(117, oldValue, value, true, false);
	}

	/**
	 * Gets the value of the invert property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isInvert() {
		return this.invert;
	}

	/**
	 * Sets the value of the invert property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setInvert(value) {
		var oldValue = this.invert;
		this.invert = value;
		this._setAndNotify(81, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the values property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the values property. <p> For example, to add a new item, do as follows: <pre> getValues().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ValueType}
	 */
	getValues() {
		if (!this.values) {
			this.values = [];
		}
		return this.values;
	}

	/**
	 * Gets the value of the location property.
	 * @return {ParameterLocationType} possible object is {@link ParameterLocationType}
	 */
	getLocation() {
		return this.location;
	}

	/**
	 * Sets the value of the location property.
	 * @param {ParameterLocationType} value allowed object is {@link ParameterLocationType}
	 */
	setLocation(value) {
		var oldValue = this.location;
		this.location = value;
		this._setAndNotify(13, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the <code>values</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ValueType</code> elements, or <code>null</code> if not set
	 */
	basicGetValues() {
		return this.values;
	}

	/**
	 * Creates a new instance of <code>ParameterFeedbackInfo</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ParameterFeedbackInfo</code> object from.
	 * @return {ParameterFeedbackInfo} an object of type <code>ParameterFeedbackInfo</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createParameterFeedbackInfo();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addValuesAt(position, item) {
		this._addAtAndNotify(this.getValues(), position, item, 83, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addValues(item) {
		this.addValuesAt(this.getValues().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeValuesAt(position) {
		this._removeAtAndNotify(this.getValues(), position, 83, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeValues(item) {
		var i = this.getValues().indexOf(item);
		if (i >= 0) {
			this.removeValuesAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ParameterFeedbackInfo";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 80, "parameterName", null));
		featureList.push(this.createFeature(false, true, false, 82, "dataType", ParameterDataType));
		featureList.push(this.createFeature(false, false, false, 118, "modelFilterItem", null));
		var clazz;
		if (factory) {
			clazz = factory.createParameterCapabilitiesType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 117, "capabilities", clazz));
		featureList.push(this.createFeature(false, false, false, 81, "invert", null));
		if (factory) {
			clazz = factory.createValueType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 83, "values", clazz));
		featureList.push(this.createFeature(false, true, false, 13, "location", ParameterLocationType));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 117:
			this.setCapabilities((value));
			break;
		case 81:
			this.setInvert((value));
			break;
		case 118:
			this.setModelFilterItem((value));
			break;
		case 82:
			this.setDataType((value));
			break;
		case 13:
			this.setLocation((value));
			break;
		case 80:
			this.setParameterName((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 83:
			this.values = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 117:
			return this.getCapabilities();
		case 81:
			return this.isInvert();
		case 118:
			return this.getModelFilterItem();
		case 82:
			return this.getDataType();
		case 83:
			return this.getValues();
		case 13:
			return this.getLocation();
		case 80:
			return this.getParameterName();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 117:
			return this.getCapabilities();
		case 81:
			return this.isInvert();
		case 118:
			return this.getModelFilterItem();
		case 82:
			return this.getDataType();
		case 83:
			return this.basicGetValues();
		case 13:
			return this.getLocation();
		case 80:
			return this.getParameterName();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 83:
			this.addValuesAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 83:
			this.addValues((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 83:
			this.removeValuesAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 83:
			this.removeValues((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ParameterFeedbackInfo.js